import { differenceInCalendarDays, format } from 'date-fns';

interface Props {
  nextDueDate: string | null | undefined;
  reminderDays?: number;
}

export function DueDateBadge({ nextDueDate, reminderDays = 7 }: Props) {
  if (!nextDueDate) {
    return <span className="text-muted-foreground text-sm">—</span>;
  }

  const diff = differenceInCalendarDays(new Date(nextDueDate), new Date());
  const formatted = format(new Date(nextDueDate), 'dd MMM yyyy');

  if (diff < 0) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-700">
        <span className="h-1.5 w-1.5 rounded-full bg-red-500 shrink-0" />
        Overdue
      </span>
    );
  }

  if (diff <= reminderDays) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700">
        <span className="h-1.5 w-1.5 rounded-full bg-amber-500 shrink-0" />
        {diff === 0 ? 'Due today' : `Due in ${diff}d`}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-700">
      <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 shrink-0" />
      {formatted}
    </span>
  );
}
